import { Injectable } from '@angular/core';
import { EntityService, HttpClient } from '@elotech/angular-common';
import { Observable } from 'rxjs';

@Injectable()
export class GeracaoArquivoService extends EntityService<any> {

  constructor(public httpClient: HttpClient) {
    super(httpClient);
    this.resource = '/api/arquivo-gerado';
  }

  post(dto: any): Observable<any> {
    return this.httpClient.post({
      resource: `${this.resource}/dto`,
      body: dto,
      location: this.location
    });
  }

  public downloadArquivo(url: any, fileName: string): Observable<any> {
    return this.httpClient.post({
      body: { url, fileName },
      resource: `${this.resource}/download`,
      disableSpinner: false,
    });
  }

  public getUrlAssinada(url: any, fileName: string): Observable<any> {
    return this.httpClient.post({
      body: { url, fileName },
      resource: `${this.resource}/url-assinada`,
      disableSpinner: false,
    });
  }

  resumo(id: any): Observable<any> {
    return this.httpClient.get({
      resource: `${this.resource}/dto/${id}`
    });
  }

}
